import { api } from '@smena/ui';

export interface AvitoConnectionView {
  id: string;
  accountId: string;
  avitoUserId: number | null;
  authKind: 'client_credentials' | 'authorization_code';
  clientId: string;
  scopes: string[];
  tariffOk: boolean;
  status: 'active' | 'inactive' | 'error' | 'no_tariff';
  hasAccessToken: boolean;
  hasRefreshToken: boolean;
  accessTokenExpiresAt: string | null;
  lastSyncAt: string | null;
  lastError: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AvitoStatusResponse {
  connection: AvitoConnectionView | null;
}

export interface AvitoConnectResponse {
  connection: AvitoConnectionView;
  probe: { tariffOk: boolean; error?: string };
}

export interface AvitoImportItemsResult {
  fetched: number;
  created: number;
  updated: number;
  skipped: number;
}

export interface AvitoImportHistoryResult {
  fetchedChats: number;
  fetchedMessages: number;
  savedDocs: number;
  skipped: number;
}

export interface AvitoImportBookingsResult {
  fetchedItems: number;
  inserted: number;
  updated: number;
  skipped: number;
  errors: number;
}

/** Путь B (OAuth). Доступен, только если стенд знает ключи нашего приложения (AVITO_OAUTH=1). */
export interface AvitoOauthConfigView {
  available: boolean;
  redirectUri: string;
  scopes: string[];
}

/**
 * Перепроверить тариф по уже сохранённым ключам, не переподключаясь.
 * Нужна, когда `tariffOk` false не по вине тарифа: подключение через OAuth до 16.09.2026
 * пробу не делало, и проба не проходит, пока не резолвлен avito_user_id.
 */
export function probeAvitoTariff(): Promise<{ tariffOk: boolean; error?: string }> {
  return api('/api/staff/avito/probe', { method: 'POST' });
}

export function fetchAvitoStatus(): Promise<AvitoStatusResponse> {
  return api('/api/staff/avito/status');
}

export function fetchAvitoOauthConfig(): Promise<AvitoOauthConfigView> {
  return api('/api/staff/avito/oauth/config');
}

export function startAvitoOauth(): Promise<{ authorizeUrl: string }> {
  return api('/api/staff/avito/oauth/start', { method: 'POST', json: {} });
}

export function connectAvito(clientId: string, clientSecret: string): Promise<AvitoConnectResponse> {
  return api('/api/staff/avito/connect', { method: 'POST', json: { clientId, clientSecret } });
}

export function disconnectAvito(): Promise<{ ok: true }> {
  return api('/api/staff/avito', { method: 'DELETE' });
}

export function importAvitoItems(): Promise<AvitoImportItemsResult> {
  return api('/api/staff/avito/import/items', { method: 'POST', json: {} });
}

export function importAvitoHistory(): Promise<AvitoImportHistoryResult> {
  return api('/api/staff/avito/import/history', { method: 'POST', json: {} });
}

export function importAvitoBookings(): Promise<AvitoImportBookingsResult> {
  return api('/api/staff/avito/import/bookings', { method: 'POST', json: {} });
}
